import { has } from 'lodash';
import { getCartoModels } from '@/carto-node/models/CoreModels';
import * as Visualization from '@/carto-node/models/visualization';
import moment from 'moment';
import { computed } from 'vue';

const cartodb_host = process.env.VUE_APP_CARTODB_SERVER;

export function isDatahubLayer(map) {
  return map && has(map, 'layerServiceInfo');
}

export function authorNameBy(map) {
  if (isDatahubLayer(map)) {
    return map?.owner;
  } else {
    return map?.permission?.owner?.username;
  }
}

export function mapThumbnailUrlBy(map, width, height) {
  if (isDatahubLayer(map)) {
    return map?.browseGraph;
  }

  return Visualization.getThumbnailUrl(map, getCartoModels(), {
    width,
    height
  });
}

export function timeAgoBy(map) {
  if (isDatahubLayer(map)) {
    return moment(map?.updateTime).fromNow();
  } else {
    if (map?.updated_at) {
      return moment(map?.updated_at).fromNow();
    } else {
      return '';
    }
  }
}

export function authorAvatarBy(map) {
  const avatar_url = map?.permission?.owner?.avatar_url;
  return avatar_url ? `${cartodb_host}/${avatar_url}` : '';
}

export function authorUrlBy(map) {
  const username = authorNameBy(map);
  return username ? `${cartodb_host}/user/${username}` : '';
}


export function useMapItem(map) {
  return {
    timeAgo: computed(() => timeAgoBy(map.value)),
    authorName: computed(() => authorNameBy(map.value)),
    authorUrl: computed(() => authorUrlBy(map.value)),
    authorAvatar: computed(() => authorAvatarBy(map.value))
  }
}